<template>
  <Understanding/>
</template>

<script>
import Understanding from '../../components/Understanding'

export default {
  components: {
    Understanding
  },
  name: 'Top'
}
</script>
